.shipment-limit-option-count {
  color: var(--gray-212c36);
}

.shipment-limit-dropdown-item-with-discount {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-8);
  width: 100%;
  flex-wrap: wrap;
}

.shipment-limit-item-volume-and-marker {
  display: flex;
  align-items: center;
  gap: var(--space-8);
  flex: 1 0 100%;
  justify-content: space-between;
}

.shipment-limit-item-strikethrough {
  text-decoration: line-through;
  color: var(--gray-8D9196);
}

.shipment-limit-item-discounted-price {
  color: var(--gray-212c36);
  flex: 1 0 100%;
  display: flex;
  justify-content: space-between;
}
